var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityViewImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 111,
    viewBox: "0 0 344 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.799 37.5039H212.985V54.8027H232.803V46.8867L240.539 41.3828L248.063 46.8867V58.4717H261.311V77.9717H267.403V71H282.135V81.3262H290.718V77.6045H300.945V85.7295H311V82H323V88H344V97H0V91H12V88H27V83.1885H39.5576V86.1357H43.6914V73.7256H57.3613V65.0762L64.25 60.1494L71.0859 65.0762V81.9033H90.2139V51.1328H104.149V63.9756H107.223V46.3633H126.511V32.7334H146.381V60.5684H155.177V38.9189H175.364V53.7012H187.552V32H200.799V37.5039Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.42 110.482C154.156 110.482 152.214 108.627 152.214 106.288V97.1729C152.214 94.9144 154.075 92.9785 156.42 92.9785C158.685 92.9785 160.627 94.8337 160.627 97.1729V106.288C160.546 108.627 158.685 110.482 156.42 110.482Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.242 110.482C206.977 110.482 205.035 108.627 205.035 106.288V97.1729C205.035 94.9144 206.896 92.9785 209.242 92.9785C211.507 92.9785 213.448 94.8337 213.448 97.1729V106.288C213.448 108.627 211.588 110.482 209.242 110.482Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.044 83.861C212.963 82.7318 212.72 81.6832 212.316 80.7152L209.727 74.8269L204.307 63.131C203.256 60.8724 200.991 59.3398 198.402 59.3398H183.033H182.871H167.502C164.995 59.3398 162.649 60.7918 161.597 63.131L156.178 74.8269L153.589 80.7152C153.185 81.6832 152.861 82.8124 152.861 83.861C152.699 87.8134 152.78 94.347 152.861 98.7028C152.942 101.284 154.964 103.301 157.553 103.301H182.871H183.033H208.352C210.94 103.301 212.963 101.284 213.044 98.7028C213.124 94.347 213.205 87.8134 213.044 83.861Z",
    fill: "#3294C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.22 73.1341L203.337 63.6966C202.932 62.7287 202.043 62.1641 200.991 62.1641H183.195H182.71H164.914C163.862 62.1641 162.972 62.8094 162.568 63.6966L158.685 73.1341C158.362 73.9407 158.928 74.828 159.818 74.828H182.629H183.114H205.925C206.896 74.828 207.543 73.9407 207.22 73.1341Z",
    fill: "#1C5170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.889 75.311C209.889 75.311 209.808 72.0039 211.426 72.0039C213.044 72.0039 215.389 72.8105 215.956 74.7464C216.603 76.7629 209.97 77.4082 209.889 75.311Z",
    fill: "#3294C5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.016 75.311C156.016 75.311 156.097 72.0039 154.479 72.0039C152.861 72.0039 150.515 72.8105 149.949 74.7464C149.302 76.7629 156.016 77.4082 156.016 75.311Z",
    fill: "#3294C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155.045 82.5689V86.2794C155.045 87.1666 155.692 87.8119 156.582 87.8926L163.619 88.1346C164.105 88.1346 164.59 87.9733 164.914 87.6506L167.179 85.5534C167.421 85.3921 167.259 84.9888 167.017 84.9888C165.237 84.8274 160.626 84.2628 155.692 82.1656C155.369 82.0043 155.045 82.2463 155.045 82.5689Z",
    fill: "#1C5170"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.102 82.5689V86.2794C211.102 87.1666 210.455 87.8119 209.565 87.8926L202.528 88.1346C202.043 88.1346 201.557 87.9733 201.234 87.6506L198.969 85.5534C198.726 85.3921 198.888 84.9888 199.131 84.9888C200.91 84.8274 205.521 84.2628 210.455 82.1656C210.779 82.0043 211.102 82.2463 211.102 82.5689Z",
    fill: "#1C5170"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M193.63 85.957L193.226 85.715C192.659 85.3117 192.012 85.1504 191.284 85.1504H182.952H182.143H173.812C173.165 85.1504 172.437 85.3924 171.87 85.715L171.466 85.957C170.819 86.441 170.495 87.2476 170.576 88.0542C170.9 89.9901 171.709 93.4585 173.165 93.4585C174.782 93.4585 180.04 93.4585 182.063 93.4585C182.548 93.4585 182.871 93.4585 182.871 93.4585C184.894 93.4585 190.152 93.4585 191.769 93.4585C193.225 93.4585 194.034 89.9901 194.358 88.0542C194.601 87.2476 194.277 86.441 193.63 85.957Z",
    fill: "#1C5170"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M159.089 95.3965C158.281 95.3965 157.553 95.7998 157.229 96.5257L156.016 98.7036C155.611 99.4296 156.177 100.397 156.986 100.397H182.629V95.3965H159.089Z",
    fill: "#1C5170"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.484 98.7036L208.271 96.5257C207.867 95.8805 207.139 95.3965 206.411 95.3965H182.062V100.397H208.514C209.323 100.397 209.889 99.4296 209.484 98.7036Z",
    fill: "#1C5170"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.16 35.0986H104V97.0999H129.16V35.0986Z",
    fill: "#999999"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.645 26.5742H108.575V35.1572H124.645V26.5742Z",
    fill: "#999999"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M117.302 5.38672H115.918V14.4498H117.302V5.38672Z",
    fill: "#999999"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.515 19.6709H111.644V26.5132H121.515V19.6709Z",
    fill: "#999999"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.987 14.5107H114.232V19.7325H118.987V14.5107Z",
    fill: "#999999"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.153 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.982 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.992 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M116.52 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.589 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.599 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.187 39.0586V97.2185",
    stroke: "#545454",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.908 17.4364C229.737 17.4364 233.651 13.5331 233.651 8.7182C233.651 3.90327 229.737 0 224.908 0C220.079 0 216.165 3.90327 216.165 8.7182C216.165 13.5331 220.079 17.4364 224.908 17.4364Z",
    fill: "#FDC812"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityViewImage);
export default __webpack_public_path__ + "static/media/city-view-image.d6cf1dfac0359298bf6f0c900d4e850b.svg";
export { ForwardRef as ReactComponent };